import { Injectable } from '@angular/core';
import { AdminConstants } from '../constants/user-constants/admin.constants';
import { EmployeeConstants } from '../constants/user-constants/employee.constants';
import { VIEW_TYPE } from '../constants/view-type.enum';
import { RequestResponse } from '../models/request-response.model';
import { CompletedMeRequestTableColumns } from '../models/table-columns/admin-table-columns.model';
import { EmployeeTableclosedDateColumns, EmployeeTableColumns } from '../models/table-columns/employee-table-columns.model';
import { LoggedInUserService } from './logged-in-user.service';

@Injectable({
    providedIn: 'root'
})
export class EmployeeService {
    newRequestsView = VIEW_TYPE.NEW_REQUESTS;
    returnedRequestsView = VIEW_TYPE.RETURNED_REQUESTS;
    requestsAssignedToMeView = VIEW_TYPE.ASSIGNED_TO_ME_REQUESTS;
    requestsInProgressView = VIEW_TYPE.INPROGRESS_REQUESTS;
    completedRequestsView = VIEW_TYPE.COMPLETED_REQUESTS;
    completedHistoryRequests=VIEW_TYPE.COMPLETED_HISTORY_REQUESTS;
    constructor(private loggedInUserService:LoggedInUserService) {}

    convertResponseToTableData(viewType: string, response: RequestResponse) {
        if (viewType === this.requestsAssignedToMeView ){
        return new EmployeeTableColumns(
            response.id,
            response.requesterData.name,
            response.service.name,
            response.requesterData.client ? response.requesterData.client.name : 'N/A',
            response.createdAt,

        );
    }
        else if(viewType === this.completedRequestsView) {
            return new EmployeeTableclosedDateColumns(
                response.id,
                response.requesterData.name,
                response.service.name,
                response.requesterData.client ? response.requesterData.client.name : 'N/A',
                response.createdAt,
                response?.icClosedAt ? response.icClosedAt : response.opsClosedAt

            );
        } 
       else if ( viewType === this.completedHistoryRequests) {
            return new CompletedMeRequestTableColumns(
                response.id,
                response.requesterData.name,
                response.service.name,
                response.requesterData.client ? response.requesterData.client.name : 'N/A',
                response.createdAt,
                response.pendingWithData,
                response.icClosedAt ? response.icClosedAt : response.opsClosedAt
            );
        }
        else {
            return undefined;
        }
    }

    getTableColumns(requestObjectName: string) {
        return EmployeeConstants[requestObjectName].tableColumn;
    }

    getTableHeaders(requestObjectName: string) {
        const displayColumns = EmployeeConstants[requestObjectName].tableColumn.map(c => c.columnDef);
        const tableWithSelection = EmployeeConstants[requestObjectName].tableWithSelection;
        if (tableWithSelection) {
            displayColumns.unshift('select');
        }

        return displayColumns;
    }

    isTableWithSelection(requestObjectName: string) {
        return EmployeeConstants[requestObjectName].tableWithSelection;
    }

    getSideMenu() {
        let list
        if(this.loggedInUserService.isEmployee()||this.loggedInUserService.includingDepartmentCode())
             list = [EmployeeConstants.ASSIGNED_TO_ME_REQUESTS, EmployeeConstants.COMPLETED_REQUESTS, AdminConstants.CALL_RECORD,];
else        list = [EmployeeConstants.ASSIGNED_TO_ME_REQUESTS, EmployeeConstants.COMPLETED_REQUESTS];

           

        let sideMenuList = [];
        list.forEach(element => {
            sideMenuList.push(element);
        });

        return sideMenuList;
    }
}
